import { Alert, Typography } from "@mui/material";

import "./LoadError.css";

export function LoadError({ fileName, message }: { fileName: string; message: string }) {
  return (
    <div className="load-error">
      <Alert severity="error" data-testid="viewer-error">
        Couldn't load {fileName}.
        <Typography variant="caption" component="div">
          {message}
        </Typography>
      </Alert>
    </div>
  );
}
